import React, { FC } from 'react'
import styled from 'styled-components'
import CircleImage from 'components/base-ui/CircleImage'
import Fonts from 'components/base-ui/Fonts'

interface ProfileProps {
  imageUrl: string
  name: string
  size: string
}

const avatarImg = `${process.env.PUBLIC_URL}/assets/dine-in/avatar.png`

const Profile: FC<ProfileProps> = ({ imageUrl, name, size }) => {
  const profileImage = imageUrl ? imageUrl : avatarImg
  return (
    <ProfileSection>
      <Fonts.SmallTitleBold>{name}</Fonts.SmallTitleBold>
      <CircleImage path={profileImage} size={size} />
    </ProfileSection>
  )
}

export default Profile

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`
